import React from 'react';
import { Images, renderStaffName, renderClientName } from 'utils';
import { SimpleTooltip } from '../tooltip';

export const NavigateCalendar = ({ staff, client, full }) => {
    const handleNavigate = () => {
        let params = {
            screenType: 'fullScreen',
            viewType: 'calendar',
        };
        if (staff) {
            params.staffs = [staff?.id];
            params.staffFull = [
                {
                    firstName: staff?.firstName,
                    lastName: staff?.lastName,
                    middleName: staff?.middleName,
                    fullName: renderStaffName(staff),
                    id: staff?.id,
                },
            ];
        }
        if (client) {
            params.clients = [client?.id];
            params.clientFull = [
                {
                    code: client?.code,
                    firstName: client?.firstName,
                    lastName: client?.lastName,
                    middleName: client?.middleName,
                    fullName: renderClientName(client),
                    id: client?.id,
                },
            ];
        }
        sessionStorage.setItem('calendarState', JSON.stringify(params));
        window.open('/schedule', '_blank');
    };

    return (
        <SimpleTooltip title={'View Calendar'} placement="top" arrow>
            {full ? (
                <button className="view-calendar-detail-btn" onClick={handleNavigate}>
                    <img src={Images.calendar} alt="" />
                    <p>Calendar</p>
                </button>
            ) : (
                <button className="view-calendar-btn" onClick={handleNavigate}>
                    <img src={Images.calendar} alt="" />
                </button>
            )}
        </SimpleTooltip>
    );
};
